import {
  NavbarMenuItemDropdown,
  NavbarMenuItemLink,
  NavbarMenuItemSubmenu,
  NavbarMenuItemType,
  useHover,
} from "@/lib/main";
import { NavbarDropdownDirectionType } from "@/lib/types/navigation/header/navbar/NavbarMenuItem.type";
import { CSSProperties, useRef } from "react";

type Props = {
  direction: NavbarDropdownDirectionType;
  isHashLinks?: boolean;
  isLastItem?: boolean;
  navbarMenuItem: NavbarMenuItemType;
};

export default function NavbarMenuItem({
  direction,
  isHashLinks,
  isLastItem = false,
  navbarMenuItem,
}: Props) {
  const { kind } = navbarMenuItem;
  const itemRef = useRef<HTMLLIElement>(null);
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();

  const liStyle: CSSProperties = {
    position: "relative",
    zIndex: "var(--z-index-header-navbar-menu-item)",
  };

  return (
    <li
      ref={itemRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={liStyle}
    >
      {kind === "link" ? (
        <NavbarMenuItemLink
          direction={direction}
          isHashLinks={isHashLinks}
          navbarMenuItem={navbarMenuItem}
        />
      ) : kind === "submenu" ? (
        <>
          <NavbarMenuItemDropdown
            direction={direction}
            isHashLinks={isHashLinks}
            isHovered={isHovered}
            navbarMenuItem={navbarMenuItem}
          />

          <NavbarMenuItemSubmenu
            anchorRef={itemRef}
            direction={direction}
            isHashLinks={isHashLinks}
            isHovered={isHovered}
            isLastItem={isLastItem}
            navbarMenuItem={navbarMenuItem}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </>
      ) : null}
    </li>
  );
}
